export const messageKindEnum = Object.freeze({
    REGULAR: 1,
    TEMPORARY: 2
});